var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reupload-book"},[_c('h2',[_vm._v("Upload new book version")]),_c('BookUploader',{attrs:{"book-id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }